import React from 'react';
import { Paper,ListSubheader } from '@mui/material';
import { useHumidityGraphDetails } from '../../data/DataProviders/HumidityGraphDataProvider';
import { isDataLoaded } from '../../types/data-providers';
import { DataIndicators } from '../DataIndicators';
import { LineGraph } from '../LineGraph/LineGraph';
import { HumidityGraphParameter } from '../../constants/lineGraphParameter';
import { Icon } from '../../lib/icons';
import chartLabelNameStyle from '../../app/insulgard/ChartLabelNameStyle';
export const HumidityGraph: React.FC = () => {
    const classes = chartLabelNameStyle();
    const responseHumidityGraphData = useHumidityGraphDetails();
    const minValueData: object[] = [];
    const maxValueData: object[] = [];
    let startDate: any;
    let endDate: any;
    const isEmpty = isDataLoaded(responseHumidityGraphData)
        ? responseHumidityGraphData.value.chartData.length === 0
        : false;
    const tickInterval = 336 * 3600 * 1000;
    if (isDataLoaded(responseHumidityGraphData)) {
        startDate = (isDataLoaded(responseHumidityGraphData) && responseHumidityGraphData.value.startDate) || '';
        endDate = (isDataLoaded(responseHumidityGraphData) && responseHumidityGraphData.value.endDate) || '';

        responseHumidityGraphData.value.chartData.filter((data: any) => {
            if (new Date(data.dateTime) >= new Date(startDate) || new Date(data.dateTime) <= new Date(endDate)) {
                const maxValue: any = parseFloat(data.maxHumidity);
                const minValue: any = parseFloat(data.minHumidity);
                const fulldate = new Date(data.dateTime).getTime();
                minValueData.push([fulldate, minValue]);
                maxValueData.push([fulldate, maxValue]);
            }
            return true;
        });
    }

    let chartLabelName;
    HumidityGraphParameter.map((temp: any) => {
        chartLabelName = temp.chartLabelName;
    });

    return (
        <div data-testid="device-info-humidity" style={{ border: '1px solid #dfe1e1', borderRadius: '5px' }}>
            <Paper elevation={0} variant="outlined" style={{ border: '0px' }}>
                <DataIndicators
                    errorMessage="Record not found"
                    emptyMessage="Record not found"
                    data={responseHumidityGraphData}
                    emptyIcon="BarChart"
                    isEmpty={isEmpty}
                    isDetailedInfo={false}
                />
            </Paper>

            {isDataLoaded(responseHumidityGraphData) && (
                <>
                    {responseHumidityGraphData.value.chartData.length > 0 && (
                        <Paper elevation={0} variant="outlined">   

                        <div className={classes.titleBoxContent}>
                                <ListSubheader color="primary" component="div" style={{ fontWeight: 600 }}>
                                   {chartLabelName}
                                    <span className={classes.icon}>
                                        {<Icon.Info className={classes.infoicon}/>}
                                    </span>
                                </ListSubheader>                               
                            </div>                           
                            <LineGraph startDate={startDate} endDate = {endDate}
                            maxValueData = {maxValueData} minValueData = {minValueData} tickInterval = {tickInterval} highChartGraphParameter = {HumidityGraphParameter}/> 
                        </Paper>
                    )}
                </>
            )}
        </div>
    );
};
